import api from './api';

export const authService = {
  async login(email, password) {
    // OAuth2PasswordRequestForm expects x-www-form-urlencoded
    const params = new URLSearchParams();
    params.append('username', email);
    params.append('password', password);
    
    const response = await api.post('/auth/login', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    // Il backend ora setta il cookie httpOnly, non restituisce più access_token
    // Salviamo solo le user info in localStorage
    if (response.data.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    const userData = response.data;
    // Aggiorna localStorage con i dati più recenti
    localStorage.setItem('user', JSON.stringify(userData));
    return userData;
  },

  async logout() {
    try {
      // Chiama backend per invalidare cookie
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Rimuovi comunque user info da localStorage
      localStorage.removeItem('user');
    }
  },

  isAuthenticated() {
    // Controlla se esiste user in localStorage (il cookie viene gestito dal browser)
    return !!localStorage.getItem('user');
  },

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
};
